import Shell from "../../components/shell";
import EnrollmentTable from "../../components/tables/enrollment-table";

const EnrollmentPage = () => {
  return (
    <div>
      <Shell pageHeader="View all members" pageTitle="Members">
        <div>
          <EnrollmentTable />
        </div>
      </Shell>
    </div>
  );
};

export default EnrollmentPage;
